import React from "react";
import { Instagram, Phone, Mail, MessageCircle } from "lucide-react";

const Footer = () => {
  return (
    <footer id="contact" className="relative mt-12 border-t" style={{ borderColor: "var(--awd-border)" }} data-testid="site-footer">
      <div className="kente-stripe" />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-16">
        <div className="footer-grid">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_eats-hub-1/artifacts/6ho2af36_Untitled_design.zip_-_2.png"
                alt="Afro World Delight"
                className="h-12 w-12 object-contain"
              />
              <div>
                <div className="font-display text-2xl">Afro World Delight</div>
                <div className="label-mini">Authentic West African Cuisine</div>
              </div>
            </div>
            <p className="text-sm max-w-md" style={{ color: "var(--awd-text-2)" }}>
              Pre-order kitchen out of Omaha, Nebraska. Cooking what we grew up loving — for you, your family, and your table.
            </p>
          </div>

          <div>
            <div className="label-mini mb-4">Pickup</div>
            <div className="font-display text-xl mb-1">Saturday, Jun 6</div>
            <div className="text-sm" style={{ color: "var(--awd-text-2)" }}>12 PM – 5 PM</div>
            <div className="text-sm" style={{ color: "var(--awd-text-2)" }}>Omaha, NE</div>
            <div className="text-xs mt-2" style={{ color: "var(--awd-text-3)" }}>Address shared after payment.</div>
          </div>

          <div>
            <div className="label-mini mb-4">Contact</div>
            <div className="flex flex-col gap-3">
              <a href="#" className="flex items-center gap-2 text-sm link-reveal w-fit" data-testid="footer-ig"><Instagram size={16} /> @afroworlddelight</a>
              <a href="sms:+14025550100" className="flex items-center gap-2 text-sm link-reveal w-fit" data-testid="footer-text"><MessageCircle size={16} /> Text us</a>
              <a href="mailto:orders@afroworlddelight.com" className="flex items-center gap-2 text-sm link-reveal w-fit" data-testid="footer-email"><Mail size={16} /> orders@afroworlddelight.com</a>
            </div>
            <div className="mt-6 p-3 border" style={{ borderColor: "var(--awd-border-2)" }}>
              <div className="label-mini" style={{ color: "var(--awd-ochre)" }}>Cash App</div>
              <div className="font-display text-xl">$deekenros</div>
            </div>
          </div>
        </div>

        <div className="section-divider my-10" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs" style={{ color: "var(--awd-text-3)" }}>
          <div>© {new Date().getFullYear()} Afro World Delight. All rights reserved.</div>
          <div className="tracking-widest uppercase">Made with fire & love · Omaha</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
